import { CartAddEvent, ThemeEvents } from '@theme/events';
document.addEventListener('DOMContentLoaded', () => {
  initializeCartDependentFeatures();

    // Tabs functionality
  const tabHeaders = document.querySelectorAll('.tab-header__tabs');
  if(tabHeaders.length > 0) {
    tabHeaders.forEach(tabHeader => {
      const tabTargets = tabHeader.querySelectorAll('.tab-target');
      if(tabTargets.length > 0) {
        tabTargets[0].classList.add('active');
        tabTargets.forEach(tabTarget => {
          tabTarget.addEventListener('click', () => {
            tabTargets.forEach(tabTarget => {
              tabTarget.classList.remove('active');
            });
            tabTarget.classList.add('active');
            const targetId = tabTarget.getAttribute('data-target');
            if(targetId) {
              const targetContent = document.getElementById(targetId);
              if(targetContent) {
                const targetParent = targetContent.closest('.tabbed-content__content');
                if(targetParent) {
                  targetParent.querySelector('.tab-content.active')?.classList.remove('active');
                }
                targetContent.classList.add('active');
              }
            }
          });
        });
      }
    });
  }
  const tabContentsSections = document.querySelectorAll('.tabbed-content__content');
  if(tabContentsSections.length > 0) {
    tabContentsSections.forEach(tabContentsSection => {
      const tabContents = tabContentsSection.querySelectorAll('.tab-content');
      if(tabContents[0]) {
        tabContents[0].classList.add('active');
      }
    });
  }
  // End of Tabs functionality
});

const initializeCartDependentFeatures = async () => {
  const cartData = await fetchCartData().catch(() => null);
  cartThresholdBar(cartData);
  checkSneakySurprise(cartData);
  const giftSelections = document.querySelectorAll('gift-selection');
  if (giftSelections.length > 0) {
    giftSelections.forEach((giftSelection) => {
      if (typeof giftSelection.init === 'function') {
        giftSelection.init(cartData);
      }
    });
  }
}

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completedText;
  
      this.timerComplete = false;
  
      this.init();
    }
  
    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
  
    }
  
    _calculate() {
      // Find time difference and convert to integer
      // Get current time in Brisbane and convert to timestamp
      const brisbaneTimestamp = +new Date(new Date().toLocaleString("en-US", {timeZone: "Australia/Brisbane"})).getTime();
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - brisbaneTimestamp;
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };
  
        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;
  
        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.display.classList.add('countdown__display--loaded');
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }
  
        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }
  
        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }
  
        this.timerComplete = true;
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);

  const addToCart = async (variantId, qty, properties) => {
    const itemData = {
      'id': variantId,
      'quantity': qty
    };
    
    if(properties) {
      itemData.properties = properties;
    }
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(itemData)
    });
    
    if(response.ok) {
      document.dispatchEvent(
        new CartAddEvent({}, variantId, {
          source: 'upsell-form-component',
          itemCount: 1,
        })
      );
      return true;
    } else {
      const errorData = await response.json().catch(() => null);
      throw new Error('Failed to add to cart: ' + (errorData?.description || response.statusText));
    }
  }

/**
 * Keeps a selected site-wide gift available while customers browse between
 * pages, but validates the cart again immediately before a gift is claimed.
 */
class TierGiftClaimController {
  storageKey = 'tier-gift-claim';
  noticeMessageTimeout;

  constructor(config) {
    this.config = config;

    document.addEventListener('click', (event) => this.handleClick(event));
    document.addEventListener(ThemeEvents.cartUpdate, () => this.validateActiveClaim());
    window.addEventListener('resize', () => this.updateUI());
    this.updateUI();
  }

  getActiveTier() {
    const tier = sessionStorage.getItem(this.storageKey);
    if (this.isEnabledTier(tier)) return tier;

    // A promotion can end or lose a tier between page loads; never retain a claim that can no longer be redeemed.
    if (tier) sessionStorage.removeItem(this.storageKey);
    return null;
  }

  isEnabledTier(tier) {
    return Boolean(this.config?.enabled && tier && this.config.tiers?.[tier]?.enabled);
  }

  async handleClick(event) {
    const startButton = event.target.closest('[data-tier-gift-claim-start]');
    if (startButton) {
      event.preventDefault();
      const tier = startButton.dataset.tier;
      const destination = startButton.href;

      if (!(await this.canClaim(tier))) {
        const failureMessage = 'This gift is no longer available because your cart no longer qualifies.';
        const cta = startButton.closest('.tier-gift-claim-cta');
        let feedback = cta?.querySelector('[data-tier-gift-claim-feedback]');

        // Keep the failed action's explanation next to the CTA that triggered it.
        if (cta && !feedback) {
          feedback = document.createElement('p');
          feedback.dataset.tierGiftClaimFeedback = '';
          cta.append(feedback);
        }

        if (feedback) {
          feedback.setAttribute('role', 'status');
          feedback.setAttribute('aria-live', 'polite');
          feedback.setAttribute('aria-atomic', 'true');
          feedback.textContent = failureMessage;
        }

        this.clearClaim(failureMessage);
        return;
      }

      sessionStorage.setItem(this.storageKey, tier);
      this.updateUI();
      window.location.assign(destination);
      return;
    }

    if (event.target.closest('[data-tier-gift-claim-cancel]')) {
      this.clearClaim('Gift selection cancelled.');
    }
  }

  async canClaim(tier) {
    if (!this.isEnabledTier(tier)) return false;

    const cart = await fetchCartData().catch(() => null);
    if (!cart) return false;

    const threshold = convertToCurrency(Number(this.config.tiers[tier].threshold));
    const cartTotal = cart.total_price && cart.total_price > 0 ? cart.total_price : cart.final_price && cart.final_price > 0 ? cart.final_price : 0;
    const rewardAlreadyClaimed = cart.items.some((item) => item.properties?._gift_tier === tier);

    return threshold > 0 && cartTotal >= threshold && !rewardAlreadyClaimed;
  }

  async prepareClaim(productForm) {
    const tier = this.getActiveTier();
    if (!tier) return {};

    // Gift cards can still be purchased while a claim is active, but never inherit a tier property.
    if (productForm.dataset.giftCard === 'true') {
      return {
        message: `Gift cards cannot be selected as your Tier ${tier} gift. Your gift selection is still active.`,
      };
    }

    if (!(await this.canClaim(tier))) {
      this.clearClaim('This gift is no longer available because your cart no longer qualifies.');
      return {
        message: 'Your cart no longer qualifies for this gift.',
        blocked: true,
      };
    }

    return { tier };
  }

  completeClaim(tier) {
    if (this.getActiveTier() === tier) {
      this.clearClaim();
    }
  }

  async validateActiveClaim() {
    const tier = this.getActiveTier();
    if (tier && !(await this.canClaim(tier))) {
      this.clearClaim('This gift is no longer available because your cart no longer qualifies.');
    }
  }

  clearClaim(message = '') {
    sessionStorage.removeItem(this.storageKey);
    this.updateUI(message);
  }

  updateUI(message = '') {
    const tier = this.getActiveTier();
    const notice = document.getElementById('tier-gift-claim-notice');
    const noticeMessage = notice?.querySelector('[data-tier-gift-claim-message]');
    const cancelButton = notice?.querySelector('[data-tier-gift-claim-cancel]');
    // A completed claim calls clearClaim without a message, which must also
    // clear the old active-state text instead of treating it as a new notice.
    const displayedMessage = tier
      ? this.config.messages?.sticky || 'Tier [tier] gift selection is active. Choose an eligible product to claim your gift.'
      : message;
    const shouldShowNotice = Boolean(tier || displayedMessage);

    if (notice) notice.classList.toggle('hidden', !shouldShowNotice);
    if (cancelButton) {
      cancelButton.toggleAttribute('hidden', !tier);
      cancelButton.disabled = !tier;

      // Keep focus on the visible status message when its focused control is no longer available.
      if (!tier && document.activeElement === cancelButton && notice) {
        notice.setAttribute('tabindex', '-1');
        notice.focus();
      }
    }
    if (noticeMessage) {
      noticeMessage.textContent = tier
        ? displayedMessage.split('[tier]').join(tier)
        : displayedMessage;
    }
    if (tier && this.noticeMessageTimeout) {
      clearTimeout(this.noticeMessageTimeout);
      this.noticeMessageTimeout = undefined;
    }
    if (!tier && message) {
      if (this.noticeMessageTimeout) clearTimeout(this.noticeMessageTimeout);
      this.noticeMessageTimeout = setTimeout(() => {
        if (!this.getActiveTier()) {
          if (noticeMessage) noticeMessage.textContent = '';
          this.noticeMessageTimeout = undefined;
          this.updateUI();
        }
      }, 10000);
    }
    // The header's sticky offset must match the bar's responsive height to prevent overlap while scrolling up.
    document.documentElement.style.setProperty('--tier-gift-claim-notice-height', shouldShowNotice && notice ? `${notice.offsetHeight}px` : '0px');

    document.querySelectorAll('product-form-component').forEach((form) => {
      const isGiftCard = form.dataset.giftCard === 'true';
      const buttonText = form.querySelector('.add-to-cart-text__content');
      const acceleratedCheckout = form.querySelector('.accelerated-checkout-block');

      if (acceleratedCheckout) {
        acceleratedCheckout.toggleAttribute('data-tier-gift-claim-hidden', Boolean(tier));
      }

      if (!buttonText) return;

      if (!buttonText.dataset.tierGiftClaimOriginalText) {
        buttonText.dataset.tierGiftClaimOriginalText = buttonText.textContent.trim();
      }

      const button = buttonText.closest('button');
      const isButtonDisabled = button?.disabled || button?.getAttribute('disabled') === 'true';
      // The configured label is resolved here because the active tier can change without a page reload.
      const claimButtonLabel = (this.config.messages?.productButton || 'Claim Tier [tier] gift').replace('[tier]', tier);
      buttonText.textContent = tier && !isGiftCard && !isButtonDisabled
        ? claimButtonLabel
        : buttonText.dataset.tierGiftClaimOriginalText;
    });
  }
}

if (typeof Theme !== 'undefined' && Theme.tierGiftClaims) {
  window.TierGiftClaim = new TierGiftClaimController(Theme.tierGiftClaims);
}

 addEventListener("change", (event) => { 
  const target = event.target;

  // Upsell variant change event
  if(target.name && target.name === 'upsell-variant') {
    const variantId = target.value;
    const parent = target.closest('.product-upsell-form');
    if(parent) {
      const atcButton = parent.querySelector('.product-upsell-form__button');
      if(atcButton) {
        atcButton.dataset.variantId = variantId;
      }
    }
  }
});

addEventListener("click", async (event) => {
  const target = event.target.closest('.product-upsell-form__button');
  if (!(target instanceof HTMLButtonElement) || target.disabled) return;

  const variantId = target.dataset.variantId;
  if (!variantId) return;

  const isGiftSelection = Boolean(target.dataset.tier && target.closest('.gift-selection-slide'));
  const buttonLabel = target.querySelector('span');
  const originalLabel = buttonLabel?.textContent;
  target.disabled = true;

  if (isGiftSelection) {
    if (buttonLabel) buttonLabel.textContent = 'Adding';
    target.setAttribute('aria-busy', 'true');
  }

  try {
    if (target.dataset.tier) {
      await addToCart(variantId, 1, { _gift_tier: target.dataset.tier });
    } else if (target.dataset.sneakySurprise) {
      await addToCart(variantId, 1, { _sneaky_surprise: 'true' });
    } else {
      await addToCart(variantId, 1);
    }
  } catch (error) {
    console.error(error);
  } finally {
    // Gift drawers stay mounted while cart contents change, so leaving a successful
    // submission disabled would make the same control read "Adding" when reopened.
    target.disabled = false;
    if (isGiftSelection) {
      target.removeAttribute('aria-busy');
      if (buttonLabel) buttonLabel.textContent = originalLabel;
    }
  }
});

const fetchCartData = async () => {
  const response = await fetch('/cart.js', {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
  const data = await response.json();
  return data;
}

const convertToCurrency = (amount) => {
  return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * Number(amount)) : Math.trunc(Number(amount))
}

// Currency decimal precision mapping
const CURRENCY_DECIMALS = {
  BHD: 3,
  BIF: 0,
  BYR: 0,
  CLF: 4,
  CLP: 0,
  DJF: 0,
  GNF: 0,
  IQD: 3,
  ISK: 0,
  JOD: 3,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  KWD: 3,
  LYD: 3,
  MRO: 5,
  OMR: 3,
  PYG: 0,
  RWF: 0,
  TND: 3,
  UGX: 0,
  UYI: 0,
  UYW: 4,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XAG: 0,
  XAU: 0,
  XBA: 0,
  XBB: 0,
  XBC: 0,
  XBD: 0,
  XDR: 0,
  XOF: 0,
  XPD: 0,
  XPF: 0,
  XPT: 0,
  XSU: 0,
  XTS: 0,
  XUA: 0,
};
const DEFAULT_CURRENCY_DECIMALS = 2;

// Format currency amount with appropriate decimal precision
const formatCurrencyAmount = (amount) => {
  const currencyCode = Shopify?.currency?.active?.toUpperCase() || '';
  const precision = (currencyCode && currencyCode in CURRENCY_DECIMALS) ? CURRENCY_DECIMALS[currencyCode] : DEFAULT_CURRENCY_DECIMALS;
  const formatted = amount.toFixed(precision);
  
  // Remove trailing zeros and decimal point if precision is 0 or if all decimals are zeros
  if (precision === 0) {
    return formatted.split('.')[0];
  }
  
  // Remove trailing zeros for currencies with decimals
  return formatted.replace(/\.?0+$/, '');
}

const removeProductFromCart = async (key, cartData = null) => {
    // Method 1: Use cart-items-component's onLineItemRemove if available
    const cartItemsComponent =  document.querySelector('cart-items-component');
    
    if(cartItemsComponent && 'onLineItemRemove' in cartItemsComponent && 
       typeof cartItemsComponent.onLineItemRemove === 'function') {
      
      let line = null;
      
      // Try to find line number from cart data
      if(cartData && 'items' in cartData && Array.isArray(cartData.items)) {
        const itemIndex = cartData.items.findIndex(item => item && 'key' in item && item.key === key);
        if(itemIndex !== -1) {
          // Line numbers are 1-based (array index is 0-based, so +1)
          line = itemIndex + 1;
        }
      }
      
      // Fallback: find line number from DOM if cart data lookup failed
      if(!line) {
        const cartItemRow = cartItemsComponent.querySelector(`[data-key="${key}"]`);
        if(cartItemRow) {
          // Find which row index this is in the cartItemRows array
          const allRows = cartItemsComponent.querySelectorAll('[ref="cartItemRows[]"]');
          const rowIndex = Array.from(allRows).indexOf(cartItemRow);
          if(rowIndex !== -1) {
            line = rowIndex + 1;
          }
        }
      }
      
      // If we found the line number, use onLineItemRemove
      if(line) {
        cartItemsComponent.onLineItemRemove(line);
        return;
      }
    }
    
    // Method 2: Fallback to direct API call if cart-items-component not available or line not found
    const response = await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    });
    if(response.ok) {
      const data = await response.json();
      if(data) {
        window.location.reload();
      }
    } else {
      const errorData = await response.json().catch(() => null);
      throw new Error('Failed to remove product from cart: ' + (errorData?.description || response.statusText));
    }
  }

// Cart Threshold Bar functionality
const cartThresholdBar = async (initialCartData = null) => {
  const settings = {
    container: 'FSTContainer',
    progress_bar: 'FSTBar',
    message: 'FSTMessage'
  }
  const container = document.getElementById(settings.container);
  if(container) {
    const script = container.closest('.cart-drawer__threshold-bar')?.querySelector('script')?.textContent;
    if(!script) {
      return;
    }
    const jsonData = JSON.parse(script);
    const enabledTargets = jsonData.targets.filter(target => target.enabled);
    const allTargets = enabledTargets.map(obj => obj.value);
    const maxTarget = Math.max(...allTargets);
    const currencySymbolObj = Theme.storeCurrency?.find(currency => currency[Shopify.currency.active]) || {};
    const currencySymbol = currencySymbolObj[Shopify.currency.active] || '$';

    if (!maxTarget || maxTarget == 0) {
      return;
    }

    const calculateProgress = (cartJson) => {
       // Sort targets from lowest to highest and remove any empty targets
      const targets = enabledTargets.sort((a, b) => a.value - b.value).filter(target => target.value);
      const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
      const cart_total = total > 0 ? total / 100 : 0;
      const progress_value = (cart_total / convertToCurrency(maxTarget)) * 100;
      let message = '';

      const progressBar = document.getElementById(settings.progress_bar);

      if (progress_value >= 100){
        progressBar.setAttribute('value', 100);
        progressBar.parentElement.setAttribute('value', 100);
      }
      else {
        progressBar.setAttribute('value', progress_value ? progress_value : 0);
        progressBar.parentElement.setAttribute('value', progress_value ? progress_value : 0);
      }

      if (cart_total <= 0) {
        message = jsonData.messaging.default;
        if(message != '' && message != null) {
          document.getElementById(settings.message).classList.add('cart-drawer__threshold-bar__default-message');
        }
      }
      else {
        for (let target of targets) {
          const remaining = convertToCurrency(target.value) - cart_total;
          const promoDot = container.querySelector(`.promotion-button.promotion--${target.name}`);
          const remaining2decimal = formatCurrencyAmount(remaining);

          if (remaining <= 0) {
            message += `<span class="message--success">
            <svg xmlns="http://www.w3.org/2000/svg" width="7.767" height="7.767" viewBox="0 0 7.767 7.767">
              <path d="M12.152,6.149a1.194,1.194,0,0,0-1.625.464L8.309,10.606,7.04,9.336a1.195,1.195,0,1,0-1.69,1.69l2.39,2.39a1.193,1.193,0,0,0,.845.351l.165-.012a1.2,1.2,0,0,0,.879-.6l2.987-5.377a1.2,1.2,0,0,0-.464-1.625Z" transform="translate(-5 -5.999)" fill="${currencySymbol}"/>
            </svg>
            <span>${target.messaging.success}</span>
            </span>`;
            if (promoDot) promoDot.classList.add('active');
          }
          else {
            message += `<span class="message--remaining">${target.messaging.ongoing.replace('[remaining]', `${currencySymbol}${remaining2decimal ? remaining2decimal : target.value}`)}</span>`;
            if (promoDot) promoDot.classList.remove('active');
            break;
          }
        }
        document.getElementById(settings.message).classList.remove('cart-drawer__threshold-bar__default-message');
      }
      // Display message
      document.getElementById(settings.message).innerHTML = message;
    }

    const renderElements = () => {
      container.innerHTML = '';
      const labelHTML = document.createElement('label')
      labelHTML.classList.add('visually-hidden');
      labelHTML.setAttribute('for', settings.progress_bar)
      labelHTML.textContent = 'Promotion progress'
  
      const progressBarHTML = document.createElement('progress')
      progressBarHTML.id = settings.progress_bar
      progressBarHTML.setAttribute('max', 100)
      progressBarHTML.setAttribute('value', 0)
      progressBarHTML.dataset.target = convertToCurrency(maxTarget);
  
      const progressBarWrapper = document.createElement('div')
      progressBarWrapper.classList.add('fst-progress-bar-wrapper')
      progressBarWrapper.dataset.target = convertToCurrency(maxTarget);
      progressBarWrapper.appendChild(progressBarHTML)
      progressBarWrapper.setAttribute('data-currency-symbol', currencySymbol);
  
      // Add all promos to progress bar wrapper
      for (const promo of enabledTargets) {
        if(promo.value > 0) {
          const elem = document.createElement('span');
          elem.dataset.target = convertToCurrency(promo.value);
          elem.dataset.currencySymbol = currencySymbol;
          elem.style.setProperty('--position', (promo.value/maxTarget) * 100);
          elem.style.setProperty('--value', `${convertToCurrency(promo.value)}`);
          elem.classList.add('promotion-button', `promotion--${promo.name}`);
          elem.setAttribute('aria-hidden', true);
          progressBarWrapper.appendChild(elem);
        }
      }
  
      container.appendChild(labelHTML);
      container.appendChild(progressBarWrapper);
  
      const messageHTML = document.createElement('div');
      messageHTML.id = settings.message;
      messageHTML.classList.add('fst-message');
  
      container.appendChild(messageHTML);
    }

    const init = async () => {
      renderElements();
      const cartData = initialCartData || await fetchCartData();
      if(cartData) {
        calculateProgress(cartData);
      }
    }

    const update = async () => {
      const cartData = await fetchCartData();
      if(cartData) {
        calculateProgress(cartData);
      }
    }

    document.addEventListener(ThemeEvents.cartUpdate, () => {
      const progressBar = document.getElementById(settings.progress_bar);
      if(progressBar) {
        update();
      } else {
        init();
      }
    });

    init();
  }
}

// Cart Gift Selection functionality
class GiftSelection extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.script = this.el.querySelector('script')?.textContent;
    if(!this.script) {
      return;
    }
    const jsonData = JSON.parse(this.script);
    this.giftTier1Threshold = convertToCurrency(parseInt(jsonData.gift_tier_1_threshold));
    this.giftTier2Threshold = convertToCurrency(parseInt(jsonData.gift_tier_2_threshold));
    this.giftTier3Threshold = convertToCurrency(parseInt(jsonData.gift_tier_3_threshold));

    this.tier1ProductSelector = this.querySelector('.cart-gift-selection__tier-1');
    this.tier2ProductSelector = this.querySelector('.cart-gift-selection__tier-2');
    this.tier3ProductSelector = this.querySelector('.cart-gift-selection__tier-3');

    this.showGiftSelectionButton = this.querySelector('.js-show-gift-selection-button');
    this.showGiftSelectionButtonShown = [];
    this.closeGiftSelectionButton = this.querySelector('.cart-drawer__close-button');


    this.tier1InCart = false;
    this.tier2InCart = false;
    this.tier3InCart = false;

    this.tier1Gift = null;
    this.tier2Gift = null;
    this.tier3Gift = null;

    this.tier1Entitlement = false;
    this.tier2Entitlement = false;
    this.tier3Entitlement = false;
  }

  async init(cartData = null) {
    const cartDataToUse = cartData || await fetchCartData();
    if(cartDataToUse) {
      this.checkTierEntitlements(cartDataToUse);
      this.checkTiersInCart(cartDataToUse);
      this.checkToRemoveGifts(cartDataToUse);
      this.showHideGiftSelectors();
      this.checkToCloseGiftSelection();
    }
  }

  checkTierEntitlements(cartData) {
    const cartTotal = cartData.total_price && cartData.total_price > 0 ? cartData.total_price : cartData.final_price && cartData.final_price > 0 ? cartData.final_price : 0;
    if(this.giftTier1Threshold && this.giftTier1Threshold > 0 && cartTotal >= this.giftTier1Threshold) {
      this.tier1Entitlement = true;
    } else {
      this.tier1Entitlement = false;
    }
    if(this.giftTier2Threshold && this.giftTier2Threshold > 0 && cartTotal >= this.giftTier2Threshold) {
      this.tier2Entitlement = true;
    } else {
      this.tier2Entitlement = false;
    }
    if(this.giftTier3Threshold && this.giftTier3Threshold > 0 && cartTotal >= this.giftTier3Threshold) {
      this.tier3Entitlement = true;
    } else {
      this.tier3Entitlement = false;
    }
  }

  checkTiersInCart(cartData) {
    this.tier1InCart = cartData.items.some(item => item.properties._gift_tier === '1');
    this.tier2InCart = cartData.items.some(item => item.properties._gift_tier === '2');
    this.tier3InCart = cartData.items.some(item => item.properties._gift_tier === '3');
    this.tier1Gift = cartData.items.find(item => item.properties._gift_tier === '1');
    this.tier2Gift = cartData.items.find(item => item.properties._gift_tier === '2');
    this.tier3Gift = cartData.items.find(item => item.properties._gift_tier === '3');
  }

  checkToRemoveGifts(cartData) {
    if(this.tier1InCart && !this.tier1Entitlement) {
      const key = this.tier1Gift.key;
      removeProductFromCart(key, cartData);
    }
    if(this.tier2InCart && !this.tier2Entitlement) {
      const key = this.tier2Gift.key;
      removeProductFromCart(key, cartData);
    }
    if(this.tier3InCart && !this.tier3Entitlement) {
      const key = this.tier3Gift.key;
      removeProductFromCart(key, cartData);
    }
  }

  showHideGiftSelectors() {
    this.showGiftSelectionButtonShown = [];
    if(this.tier1ProductSelector) {
      if(this.giftTier1Threshold && this.giftTier1Threshold > 0 && this.tier1Entitlement && !this.tier1InCart) {
        this.showGiftSelectionButtonShown.push('true');
        this.tier1ProductSelector.classList.remove('hidden');
      } else {
        this.showGiftSelectionButtonShown.push('false');
        this.tier1ProductSelector.classList.add('hidden');
      }
    }
    if(this.tier2ProductSelector) {
      if(this.giftTier2Threshold && this.giftTier2Threshold > 0 && this.tier2Entitlement && !this.tier2InCart) {
        this.showGiftSelectionButtonShown.push('true');
        this.tier2ProductSelector.classList.remove('hidden');
      } else {
        this.showGiftSelectionButtonShown.push('false');
        this.tier2ProductSelector.classList.add('hidden');
      }
    }
    if(this.tier3ProductSelector) {
      if(this.giftTier3Threshold && this.giftTier3Threshold > 0 && this.tier3Entitlement && !this.tier3InCart) {
        this.showGiftSelectionButtonShown.push('true');
        this.tier3ProductSelector.classList.remove('hidden');
      } else {
        this.showGiftSelectionButtonShown.push('false');
        this.tier3ProductSelector.classList.add('hidden');
      }
    }
    if(this.showGiftSelectionButton) {
      if(this.showGiftSelectionButtonShown && this.showGiftSelectionButtonShown.includes('true')) {
        this.showGiftSelectionButton.classList.remove('hidden');
      } else {
        this.showGiftSelectionButton.classList.add('hidden');
      }
    }
  }

  checkToCloseGiftSelection() {
    if(this.showGiftSelectionButtonShown && this.showGiftSelectionButtonShown.includes('true')) {
      return;
    }
    
    // Method 1: Simulate click on the close button
    if(this.closeGiftSelectionButton && this.closeGiftSelectionButton instanceof HTMLButtonElement) {
      this.closeGiftSelectionButton.click();
    } else {
      // Method 2: Fallback - directly call the cart drawer component's close method
      const cartDrawer = this.closest('cart-drawer-component');
      if(cartDrawer && 'close' in cartDrawer && typeof cartDrawer.close === 'function') {
        cartDrawer.close();
      }
    }
  }

  connectedCallback() {
    // this.init();
    document.addEventListener(ThemeEvents.cartUpdate, () => {
      this.init();
    });
  }
}
customElements.define('gift-selection', GiftSelection);

const checkSneakySurprise = async (cartData = null) => {
  const cartDataToUse = cartData || await fetchCartData();
  if(cartDataToUse) {
    const sneakySurpriseItems = cartDataToUse.items.filter(item => item.properties._sneaky_surprise === 'true');
    if(sneakySurpriseItems.length > 0) {
      let sneakySurpriseAllowed = false;
      for(const item of cartDataToUse.items) {
        const productType = item.product_type.toLowerCase();
        if(productType == "bottoms" || productType == "tops" || productType == "top" || productType == "bottom" || productType == "one piece" || productType == "one-piece" || productType == 'shorts' || productType == 'leggings') {
          if(item.properties._sneaky_surprise === 'true') {
          } else {
            sneakySurpriseAllowed = true;
            break;
          }
        }
      }
      if(!sneakySurpriseAllowed) {
        sneakySurpriseItems.forEach(item => {
          const key = item.key;
          removeProductFromCart(key, cartDataToUse);
        });
      }
    }
  }
}

document.addEventListener(ThemeEvents.cartUpdate, () => {
  checkSneakySurprise();
});

class StickyMobileNav extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.openMenuButton = this.querySelector('.sticky-mobile-navigation__open-menu');
    this.cartButton = this.querySelector('.sticky-mobile-navigation__cart-button');
  }

  connectedCallback() {
    if(this.openMenuButton) {
      this.openMenuButton.addEventListener('click', () => {
        const menu = document.querySelector('.menu-drawer-container');
        if(menu) {
          menu.classList.add('menu-open');
          menu.setAttribute('open', "true");
        }
      });
    }
    if(this.cartButton) {
      this.cartButton.addEventListener('click', () => {
        const cartDrawer = document.querySelector('cart-drawer-component');
        if(cartDrawer) {
          cartDrawer.open();
        }
      });
    }
    document.addEventListener('scroll', this.handleWindowScroll.bind(this));
    this.handleHtmlAttributeChange();
  }

  handleWindowScroll() {
    const headerContainer = document.querySelector('header-component');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.el.classList.add('hidden');
          // Stop observing the element once it's visible
          observer.unobserve(entry.target);
        } else {
          this.el.classList.remove('hidden');
        }
      });
    });
    
    if (headerContainer) {
      observer.observe(headerContainer);
    }
  }

  handleHtmlAttributeChange() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if(mutation.attributeName === 'scroll-lock') {
          if(mutation.target.hasAttribute('scroll-lock')) {
            this.el.classList.add('hidden');
          } else {
            // Only remove hidden class if header is not in viewport
            const headerContainer = document.querySelector('header-component');
            if(headerContainer) {
              const rect = headerContainer.getBoundingClientRect();
              // Check if header is completely out of viewport (not intersecting)
              const isInViewport = rect.bottom >= 0 && rect.top <= window.innerHeight;
              if(!isInViewport) {
                this.el.classList.remove('hidden');
              }
            } else {
              this.el.classList.remove('hidden');
            }
          }
        }
      });
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scroll-lock'],
    });
  }
}

customElements.define('sticky-mobile-nav', StickyMobileNav);
